
function ContactMap(){

    this.build();

}

ContactMap.prototype.build = function(){

    if( $("#map").length > 0 ){

        let that = this;

        let bounds = new google.maps.LatLngBounds();
        let icon = $('#map').data('pointer');

        map = new google.maps.Map(document.getElementById('map'), {
            center: {
                lat: 46.203391,
                lng: 6.146954
            },
            zoom: 16,
            streetViewControl: false,
            mapTypeControl: false,
            fullscreenControl: false,
            zoomControlOptions: {
                position: google.maps.ControlPosition.RIGHT_BOTTOM
            },
            styles: [
                {
                    "featureType": "all",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "saturation": 36
                        },
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 40
                        }
                    ]
                },
                {
                    "featureType": "all",
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "visibility": "on"
                        },
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 16
                        }
                    ]
                },
                {
                    "featureType": "all",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 20
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 17
                        },
                        {
                            "weight": 1.2
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 20
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 21
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 17
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 29
                        },
                        {
                            "weight": 0.2
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 18
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 16
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 19
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#000000"
                        },
                        {
                            "lightness": 17
                        }
                    ]
                }
            ]
        });

        marker = new google.maps.Marker({
            position: {
                lat: 46.203391,
                lng: 6.146954
            },
            map: map,
            icon : icon
        });

        // $('.map-cities-list-item').each(function(){
        //
        //     var markerID = $(this).data('id');
        //     var address = $(this).data('address');
        //     var kml = $(this).data('kml');
        //     var detail = $(this).data('detail');
        //     var url = $(this).data('url');
        //
        //     marker = new google.maps.Marker({
        //         id: markerID,
        //         // top : top,
        //         address: address,
        //         position: {
        //             lat: $(this).data('lat'),
        //             lng: $(this).data('lng')
        //         },
        //         map: map,
        //         icon : ( detail != "" ) ? icon : iconSimple
        //     });
        //     if( url ){
        //         marker.addListener('click', function(){
        //             barba.go(url);
        //             // window.location.href = url;
        //         });
        //     }
        //
        //     marker.addListener('mouseover', function() {
        //         that.showPolygon( markerID );
        //         $(".map-cities-list-item[data-id="+markerID+"]").addClass('marker--hover');
        //     });
        //
        //     marker.addListener('mouseout', function() {
        //         that.hidePolygon( markerID );
        //         $(".map-cities-list-item[data-id="+markerID+"]").removeClass('marker--hover');
        //     });
        //
        //     markers[ markerID ] = marker;
        //     bounds.extend(marker.getPosition());
        //
        // })
        //     .on('mouseenter', function(){
        //         that.showPolygon( $(this).data('id') );
        //         map.panTo(markers[ $(this).data('id') ].getPosition() );
        //         markers[ $(this).data('id') ].setAnimation(google.maps.Animation.BOUNCE);
        //     })
        //     .on('mouseleave', function(){
        //         that.hidePolygon( $(this).data('id') );
        //         markers[ $(this).data('id') ].setAnimation(null);
        //     });

        // map.fitBounds(bounds);

        this.map = map;
        this.bounds = bounds;
        // resizeCallbacks.push(this);
        // this.resize();

    }
};
